import React, { Fragment, useState, useEffect, useContext, useRef } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Breadcrumbs, Btn } from "../../../AbstractElements";
import TripTable from "./TripTable";
import FilterTable from "../../Common/Component/FilterTable";
import SearchTable from "../../Common/Component/SearchTable";
import {
  tripFilterColumns,
  searchColumns,
} from "../../../Data/Trips/TripHistory";
import SharedDataContext from "../../../_helper/SharedData";
import {
  getTrips,
  getTripCount,
  getTripTableSearchData,
  getTripTableFilterData,
  getTripStatus,
} from "../../../Services/Trip.service";
import SelectedFilter from "./SelectedFilter";
import { showAlert, formatDateTime } from "../../../Services/Shared.service";
import { getBookingViaType } from "../../../Services/Booking.service";
import moment from "moment";
import { useLocation } from "react-router";
import { CSVLink } from "react-csv";
import { Download } from "react-feather/dist";
const TripHistory = () => {
  const location = useLocation();
  const [searchData, setSearchData] = useState(location.state?.searchdata ? location.state?.searchdata : "");
  const [loader, setLoader] = useState(false);
  const { globalCityField, setShowApiLoader, setPageNumber, dateFilter } =
    useContext(SharedDataContext);
  const localFromDate = moment(dateFilter.startDate).set({ h: 0, m: 0, s: 0, ms: 0 });
  const localToDate = moment(dateFilter.endDate).set({ h: 23, m: 59, s: 59, ms: 999 });
  const FormatFromDate = formatDateTime(
    localFromDate,
    "YYYY-MM-DD"
  );
  const FormatToDate = formatDateTime(localToDate, "YYYY-MM-DD");
  const firstUpdate = useRef(true);
  const [filterType, setFilterType] = useState(location.state?.filterdata?.length > 0 ? "filter" : location.state?.searchdata ? "search" : "");

  const [tripData, setTripData] = useState([]);

  const [paginationTotalRows, setPaginationTotalRows] = useState(0);

  const [pagination, setPagination] = useState(location.state?.pageNumber ? location.state.pageNumber : 0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const [tripStatusData, setTripStatusData] = useState([]);
  const [bookingViaTypeData, setBookingViaTypeData] = useState([]);

  const [filterData, setFilterData] = useState(location.state?.filterdata?.length > 0 ? location.state?.filterdata : []);
  const [exportData, setExportData] = useState([]);

  let columns = [];
  tripFilterColumns.map((element) => {
    if (element.value) {
      columns.push({
        value: {
          name: element.name,
          value: element.value,
          type: element.type,
        },
        label: element.name,
      });
    }
  });

  const disableLoaders = () => {
    setLoader(false);
    // setShowApiLoader(false);
  };

  const removeFilter = (index) => {
    const newfilterData = [...filterData];
    newfilterData.splice(index, 1);
    setFilterData(newfilterData);
  };
  const fetchTripData = async ({isSearchFilterPage}) => {
    const serviceCityId = globalCityField.value?.id?.toString() || 0;
    const filterCityId = globalCityField.value?.id?.toString() || null;
    const obj = {
      page: pagination,
      size: rowsPerPage,
      serviceCityId: serviceCityId ? serviceCityId : null,
      fromDate: FormatFromDate,
      toDate: FormatToDate,
    };
    console.log(filterData, searchData, filterType, "filterType");
    if (filterData.length == 0 && !searchData) {
      setLoader(true);
      getTrips(obj)
        .then((result) => {
          setTripData(result.data.list);
          setPaginationTotalRows(result.data.count);
          disableLoaders();
        })
        .catch((err) => {
          disableLoaders();
          setTripData([]);
          showAlert("error", "Something went wrong");
        });
      // let pageObj = {
      //   serviceCityId: serviceCityId ? serviceCityId : null,
      //   fromDate: FormatFromDate,
      //   toDate: FormatToDate,
      // };
      // getTripCount(pageObj).then((result) => {
      //   if (result.data) {
      //     setPaginationTotalRows(result.data);
      //   }
      // });
    } else if (filterData.length > 0 && filterType == "filter") {
      let body = [
        // {
        //   type: "Trip",
        // },
        {
          service_city: filterCityId,
        },
        {
          from: FormatFromDate,
          to: FormatToDate
        },
      ];
      filterData.forEach((element) => {
        body.push({
          column_name: element.column_name,
          value: element.values[0],
        });
      });
      setLoader(true);
      getTripTableFilterData({ ...obj, page: isSearchFilterPage }, body)
        .then((result) => {
          if (result.data) {
            const data = result.data?.filterResponse || [];
            setTripData(data);
            setPaginationTotalRows(result.data.count);
            disableLoaders();
          }
        })
        .catch((err) => {
          disableLoaders();
          setTripData([]);
          showAlert("error", "Something went wrong");
        });
    } else if (searchData && filterType == "search") {
      let body = [
        // {
        //   type: "Trip",
        // },
        {
          service_city: filterCityId,
        },
        {
          from: FormatFromDate,
          to: FormatToDate
        },
        {
          column_names: searchColumns,
          value: searchData,
        },
      ];
      setLoader(true);
      getTripTableSearchData(
        { ...obj, page: isSearchFilterPage },
        body
      )
        .then((result) => {
          if (result.data) {
            const data = result.data?.searchResponse || [];
            setTripData(data);
            setPaginationTotalRows(result.data.count);
            disableLoaders();
          }
        })
        .catch((err) => {
          disableLoaders();
          setTripData([]);
          showAlert("error", "Something went wrong");
        });
    }
  };

  useEffect(() => {
    setPageNumber(0);
    getTripStatus().then((result) => {
      if (result.status == 200 && result.data.length > 0) {
        const data = [];
        result.data.forEach((element) => {
          data.push({
            value: element,
            label: element,
          });
        });
        setTripStatusData(data);
      }
    });
    getBookingViaType().then((result) => {
      if (result.status == 200 && result.data.length > 0) {
        const data = [];
        result.data.forEach((element) => {
          data.push({
            value: element,
            label: element,
          });
        });
        setBookingViaTypeData(data);
      }
    });
  }, []);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    fetchTripData({isSearchFilterPage: pagination});
  }, [dateFilter.startDate, dateFilter.endDate])

  const onChangePage = (page) => {
    setPagination(page - 1);
  };

  const onChangeRowsPerPage = (currentRowsPerPage) => {
    setRowsPerPage(currentRowsPerPage);
  };

  useEffect(() => {
    if (filterData.length == 0 && filterType != "filter") return;
    fetchTripData({isSearchFilterPage: 0});
  }, [filterData]);

  useEffect(() => {
    if (!searchData && filterType != "search") return;
    fetchTripData({isSearchFilterPage: 0});
  }, [searchData]);

  useEffect(() => {
    fetchTripData({isSearchFilterPage: pagination});
  }, [pagination, rowsPerPage, globalCityField.value]);

  useEffect(() => {
    if (tripData.length > 0) {
      let eData = tripData.map((d) => {
        return {
          "BOOKING #": d.megaCabsBookingNo,
          "PICKUP TIME": new Date(d.pickUpDateTime),
          "CUSTOMER NAME": d.custName,
          "PHONE": d.custMobile,
          "PICKUP": d.pickUpAddress,
          "DROP": d.destAddress,
          "STATUS": d.currentBookingStatusType,
          "DRIVER ASSIGNED": d.driverName,
          "CAR TYPE": d.carType,
          "BOOKING VIA": d.bookingViaType,
        }
      })
      setExportData(eData)

    }
  }, [tripData])

  return (
    <Fragment>
      <Breadcrumbs
        parent="Trip Management"
        subParent="All Trips"
        mainTitle="All Trips"
        exportBtn={
          <Btn attrBtn={{ style: { display: "flex", padding: "7px 14px 5px", justifyContent: "center", alignItems: "center" },title: "Export" }}>
            <CSVLink data={exportData} filename={"Trip_History"} style={{ color: "white" }}><Download size={"20px"}/></CSVLink>
          </Btn>
        }
        span1={
          <FilterTable
            options={columns}
            setFilterData={setFilterData}
            filterData={filterData}
            setSearchData={setSearchData}
            setFilterType={setFilterType}
            statusData={tripStatusData}
            bookingViaTypeData={bookingViaTypeData}
          />
        }
        span3={
          <SearchTable
            setFilterType={setFilterType}
            searchData={searchData}
            setSearchData={setSearchData}
            setFilterData={setFilterData}
          />
        }
      />
      <Container fluid={true} className="datatables">
        <Row className="selected-filter">
          {filterData.map((element, i) => {
            return (
              <SelectedFilter
                key={i}
                element={element}
                index={i}
                removeFilter={removeFilter}
              />
            );
          })}
          {/* {filterData.length > 0 ? (
            <div className="save-filter">Save Filter</div>
          ) : (
            ""
          )} */}
        </Row>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody className="p-0">
                  <TripTable
                    tripData={tripData}
                    onChangePage={onChangePage}
                    paginationPerPage={rowsPerPage}
                    paginationTotalRows={paginationTotalRows}
                    onChangeRowsPerPage={onChangeRowsPerPage}
                    pagination={pagination}
                    setPageNumber={setPageNumber}
                    pageNumber={
                      location.state?.pageNumber
                        ? location.state.pageNumber + 1
                        : 1
                    }
                    loader={loader}
                    filterData={filterData}
                    searchData={searchData}
                    fetchTripData={()=>{
                      fetchTripData({isSearchFilterPage: pagination});
                    }}
                  />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default TripHistory;
